import { FeatureProfile } from '@mdlbeasts/nofomo.ui.web';
import type { SxProps, Theme } from '@mui/material';

import { type FavouriteType, useFavouriteToggle } from 'restful/accounts';

const UI_TYPE: Record<FavouriteType, FeatureProfile.Favorites.FavoriteType> = {
  artist: 'favorite',
  event: 'bookmark',
};

export interface FavoriteToggleProps {
  type: FavouriteType;
  value: string;
  variant?: FeatureProfile.Favorites.FavoriteToggleVariant;
  sx?: SxProps<Theme>;
  testID?: string;
}

const FavoriteToggle = ({
  type,
  value,
  variant,
  sx,
  testID,
}: FavoriteToggleProps) => {
  const { active, toggle } = useFavouriteToggle(type, value);

  return (
    <FeatureProfile.Favorites.FavoriteToggle
      active={active}
      onToggle={toggle}
      sx={sx}
      testID={testID}
      type={UI_TYPE[type]}
      variant={variant}
    />
  );
};

export default FavoriteToggle;
